export const medicalTypeMapping = {
    baseline: 'Baseline',
    periodic: 'Periodic',
    return_to_work: 'Return to Work',
    exit: 'Exit',
    chronic_care: 'Chronic care',
    workplace_disease: 'Workplace disease',
    general: 'General',
};
